import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";

//import Container from "react-bootstrap/Container";

import Nav from "react-bootstrap/Nav";
import { GrApps } from "react-icons/gr";
import { IoAppsSharp } from "react-icons/io";
import { SiTrello } from "react-icons/si";
import { AiOutlineInfoCircle, AiOutlineBell } from "react-icons/ai";
import { MdApps, MdKeyboardArrowDown } from "react-icons/md";

export default class TopNavbar extends Component {
  render() {
    return (
      <>
        <Navbar bg="#026AA7">
          <Navbar.Brand
            href="#home"
            id="reply"
            style={{
              display: "flex",
              gap: "5px",
              backgroundColor: "#026AA7",
              alignSelf: "flex-start",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              marginLeft: "10px",
            }}
          >
            <MdApps style={{ color: "white", width: "26px", height: "26px" }} />
            <SiTrello
              style={{ color: "white", width: "22px", height: "22px" }}
            />
            <span style={{ fontWeight: "800", color: "white" }}>Trello</span>
          </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="#home" style={{ color: "white", display: "flex" }}>
              WorkSpace <MdKeyboardArrowDown />
            </Nav.Link>
            <Nav.Link
              href="#features"
              style={{ color: "white", display: "flex" }}
            >
              Recent
              <MdKeyboardArrowDown />
            </Nav.Link>
            <Nav.Link
              href="#pricing"
              style={{ color: "white", display: "flex" }}
            >
              Stared
              <MdKeyboardArrowDown />
            </Nav.Link>
            <Nav.Link
              href="#pricing"
              style={{ color: "white", display: "flex" }}
            >
              Template
              <MdKeyboardArrowDown />
            </Nav.Link>
            <button
              style={{
                color: "white",
                backgroundColor: "#0265",
                padding: "10px",
                borderRadius: "5px",
              }}
            >
              Create
            </button>
          </Nav>

          <input
            type="text"
            style={{
              marginRight: "70px",
              backgroundColor: "#2189c5",
              borderColor: "white",
              borderRadius: "4px",
              height: "26px",
              padding: "10px",
              border: "1px solid gray",
            }}
            placeholder="search"
          />

          <div
            className="icons"
            style={{
              display: "flex",
              marginLeft: "-70px",
              gap: "8px",
              paddingLeft: "10px",
            }}
          >
            <AiOutlineInfoCircle
              style={{
                color: "white",
                width: "22px",
                height: "22px",
                marginTop: "7px",
              }}
            />
            <AiOutlineBell
              style={{
                color: "white",
                width: "22px",
                height: "22px",
                marginTop: "7px",
              }}
            />
            <Image
              src="https://images.unsplash.com/photo-1544723795-3fb6469f5b39?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzd8fHBlcnNvbnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
              style={{
                height: "40px",
                width: "40px",
                objectFit: "cover",
                borderRadius: "50%",
                margin: "2px",
              }}
            />
          </div>
        </Navbar>
      </>
    );
  }
}
